import React from 'react';
import { Link } from 'react-router-dom';
import verified from '../../images/verified-blue.svg';

export default class SubscriptionConfirmation extends React.Component {

  render() {
    return (
      <div className='row confirmation'>
        <div className='col-sm-12'>
          Done! You now have unlimited tacks (and this badge 
            <span className='verified-mark-15-inline'>
              &nbsp;<img src={verified} alt='Verified and Unlimited' />
          </span>).
        </div>
        <div className='col-sm-12 action center'>
          <Link to='/' className='btn btn-dark' data-primary-cta='true'>Awesome</Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/subscription/subscription_confirmation.jsx